import { supabase } from "./supabase";

const TENANT_DOMAIN = "ikone.rs";

async function getTenantId() {
  const { data, error } = await supabase
    .from("tenants")
    .select("id")
    .eq("domain", TENANT_DOMAIN)
    .single();
  if (error) throw error;
  return data.id;
}

export async function createOrder({ customer, items, total, opstina, delivery_date, delivery_hour, delivery_zone_id }) {
  const tenantId = await getTenantId();

  const { data, error } = await supabase
    .from("orders")
    .insert({
      tenant_id: tenantId,
      customer,
      items,
      total,
      status: "pending",
      opstina: opstina || null,
      delivery_date: delivery_date || null,
      delivery_hour: delivery_hour || null,
      delivery_zone_id: delivery_zone_id || null,
    })
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function decrementStock(productId, qty = 1) {
  const { error } = await supabase.rpc("decrement_stock", {
    product_id: productId,
    qty,
  });
  if (error) throw error;
}
